export function hasImage(message) {
    if (message.media_url && message.media_url.match(/\.(png|jpg|jpeg|gif|bmp)/)) {
        return true;
    }

    return (message.media_content_type || '').toLowerCase().includes('image');
}

export function hasVideo(message) {
    if (message.media_url && message.media_url.match(/\.(mp4|webm)/)) {
        return true;
    }

    return (message.media_content_type || '').toLowerCase().includes('video');
}

export function hasAudio(message) {
    if (message.media_url && message.media_url.match(/\.(mp3|mpeg|ogg|wav)/)) {
        return true;
    }

    return (message.media_content_type || '').toLowerCase().includes('audio');
}

export function hasPDF(message) {
    if (message.media_url && message.media_url.match(/\.(pdf)/)) {
        return true;
    }

    return (message.media_content_type || '').toLowerCase().includes('pdf');
}

export function hasVcard(message) {
    if (message.media_url?.match(/\.(vcf|vcard)/)) {
        return true;
    }

    return (message.media_content_type || '').toLowerCase().includes('vcard');
}

export function messageErrorDescription(vendor, errorCode) {
    if (vendor === 'bandwidth') {
        switch (errorCode) {
            case '4303':
                return 'Invalid number';
            case '4360':
                return 'Validity period elapsed';
            case '4404':
                return 'Messaging forbidden';
            case '4406':
                return 'Unallocated number';
            case '4420':
                return 'Unreachable number';
            case '4470':
                return 'Carrier filtered';
            case '4475':
                return 'Unsubscribed recipient';
            case '4476':
                return 'Unregistered number';
            case '4482':
                return 'Blocked number';
            case '4700':
                return 'Invalid service';
            case '4701':
                return 'Unavailable service';
            case '4702':
                return 'Unavailable subscriber';
            case '4711':
                return 'Content too large';
            case '4720':
                return 'Invalid destination';
            case '4721':
                return 'Deactivated destination';
            case '4730':
                return 'No route to carrier';
            case '4775':
                return 'Carrier unsubscribed';
            case '9999':
                return 'Unknown carrier error';
        }
    }

    if (vendor === 'twilio') {
        switch (errorCode) {
            case '21610':
                return 'Unsubscribed recipient';
            case '21211':
                return 'Invalid number';
            case '21265':
                return 'Short code number';
            case '21268':
                return 'Premium rate number';
            case '21408':
                return 'Invalid region';
            case '21611':
                return 'Queue full';
            case '21612':
                return 'Unreachable number';
            case '21614':
                return 'Not mobile number';
            case '21635':
                return 'Landline number';
            case '30001':
                return 'Queue overflow';
            case '30003':
                return 'Unreachable destination';
            case '30005':
                return 'Unknown destination';
            case '30006':
                return 'Landline or unreachable';
            case '30007':
                return 'Carrier filtered';
            case '30008':
                return 'Unknown carrier error';
            case '30011':
                return 'MMS not supported in region';
            case '30019':
                return 'Content too large';
            case '30024':
                return 'Sender not provisioned';
            case '30034':
                return 'Unregistered number';
            case '30036':
                return 'Validity period elapsed';
            case '30500':
                return 'Internal error';
        }
    }

    switch (errorCode) {
        case '29000':
            return 'Team not active';
        case '29001':
            return 'Blocked number';
        case '29002':
            return 'Banned content';
        case '29003':
            return 'Too many segments';
        case '29004':
            return 'Blocked region';
        case '29005':
            return 'Too many characters';
        case '29006':
            return 'Invalid number';
        case '29100':
            return 'Message too old';
        case '29101':
            return 'Quota exceeded';
        case '29200':
            return 'Vendor API error';
        case '29300':
            return 'Accepted timeout';
        case '29301':
            return 'Queued timeout';
        case '29302':
            return 'Processing timeout';
    }

    return 'Unknown error';
}

export const ALLOWED_IMAGE_TYPES = ['image/gif', 'image/jpeg', 'image/png', 'image/heic'];
export const ALLOWED_FILE_TYPES = [
    'video/mp4',
    'audio/mpeg',
    'text/csv',
    'application/pdf',
    'text/vcard',
    'text/x-vcard',
];
